/**
 * Mirrors the server's project design lock (src/middleware/project-edit-lock.ts):
 * a project's approved design - core fields, logframe, workplan, targets,
 * locations, MEAL plan and budget - is editable only in Draft or Returned
 * for redraft. Used only to hide edit controls; the server enforces it
 * independently. Monitoring (indicator actuals, risks, team) is not locked.
 */
export const EDITABLE_PROJECT_STATUSES = ['draft', 'returned'];
export function isProjectDesignEditable(status: string | null | undefined): boolean {
  return !!status && EDITABLE_PROJECT_STATUSES.includes(status);
}
